// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p5Xz","largestCol":"styles_largestCol__2TyZe","smallestCol":"styles_smallestCol__1IgpC"};